import { render, staticRenderFns } from "./RapportsNdellice.vue?vue&type=template&id=212dc954&scoped=true"
import script from "./RapportsNdellice.vue?vue&type=script&lang=js"
export * from "./RapportsNdellice.vue?vue&type=script&lang=js"
import style0 from "./RapportsNdellice.vue?vue&type=style&index=0&id=212dc954&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "212dc954",
  null
  
)

export default component.exports